var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"accessibility__title"},[_vm._v("jowett.me")]),_c('logo',{attrs:{"title":"Jowett.me"}}),_c('Navigation',{attrs:{"show-burger":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }